
import { Link } from 'react-router-dom';

export default function Terms() {
  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header */}
      <header className="bg-black/90 backdrop-blur-sm border-b border-amber-500/20 sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center">
              <Link to="/" className="text-2xl font-bold text-amber-400 cursor-pointer" style={{fontFamily: "Pacifico, serif"}}>奇跡のブラックアウト</Link>
            </div>
            <nav className="hidden md:flex space-x-8">
              <Link to="/" className="text-white hover:text-amber-400 transition-colors cursor-pointer">ホーム</Link>
              <Link to="/terms" className="text-amber-400 cursor-pointer">利用規約</Link>
              <Link to="/privacy" className="text-white hover:text-amber-400 transition-colors cursor-pointer">プライバシーポリシー</Link>
              <Link to="/contact" className="text-white hover:text-amber-400 transition-colors cursor-pointer">お問い合わせ</Link>
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-gray-900/50 border border-amber-500/20 rounded-2xl p-8 md:p-12">
          <h1 className="text-4xl md:text-5xl font-bold text-amber-400 mb-8 text-center">利用規約</h1>
          
          <div className="space-y-8 text-gray-300">
            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">第1条（適用）</h2>
              <p className="leading-relaxed">
                この利用規約（以下「本規約」といいます。）は、運営（以下「当運営」といいます。）がこのモバイルアプリケーション「奇跡のブラックアウト」（以下「本アプリ」といいます。）上で提供するサービス（以下「本サービス」といいます。）の利用条件を定めるものです。登録ユーザーの皆さま（以下「ユーザー」といいます。）には、本規約に従って、本サービスをご利用いただきます。
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">第2条（定義）</h2>
              <p className="leading-relaxed mb-4">
                本規約において使用する用語の意義は、次の各号に定めるところによります。
              </p>
              <ol className="list-decimal pl-6 space-y-2">
                <li>「運営」とは、本アプリの提供者をいいます。</li>
                <li>「利用者」とは、本アプリを利用する個人をいいます。</li>
                <li>「本アプリ」とは、運営が提供する「脳汁ブラックアウト」アプリケーションをいいます。</li>
                <li>「コンテンツ」とは、本アプリ内に表示される文章、画像、音声、動画、その他の情報をいいます。</li>
              </ol>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">第3条（本アプリについて）</h2>
              <p className="leading-relaxed mb-4">
                「奇跡のブラックアウト」は、パチスロのフリーズ演出を疑似体験できるシミュレーションアプリです。
              </p>
              <ol className="list-decimal pl-6 space-y-2">
                <li>本アプリは、パチスロのフリーズ演出を疑似体験するためのエンターテイメントアプリケーションです。</li>
                <li>本アプリは、実際のパチスロ機とは一切関係なく、金銭の授受を伴うギャンブルではありません。</li>
                <li>本アプリの利用により、実際の金銭を獲得することはできません。</li>
                <li>本アプリは、18歳未満の方の利用を推奨しません。</li>
              </ol>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">第4条（利用条件）</h2>
              <ol className="list-decimal pl-6 space-y-2 leading-relaxed">
                <li>本アプリは、個人の娯楽目的での利用に限定されます。</li>
                <li>利用者は、本アプリを適法に利用するものとします。</li>
                <li>利用者は、本アプリの利用により生じた結果について、自己の責任において対処するものとします。</li>
              </ol>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">第5条（禁止事項）</h2>
              <p className="leading-relaxed mb-4">
                利用者は、本アプリの利用にあたり、以下の行為を行ってはならないものとします。
              </p>
              <ol className="list-decimal pl-6 space-y-2">
                <li>法令または公序良俗に違反する行為</li>
                <li>犯罪行為に関連する行為</li>
                <li>本アプリの内容の無断複製、変更、配布、販売等の行為</li>
                <li>本アプリの運営を妨害する行為</li>
                <li>他の利用者に迷惑をかける行為</li>
                <li>運営または第三者の知的財産権を侵害する行為</li>
                <li>運営または第三者の名誉・信用を毀損する行為</li>
                <li>その他、運営が不適切と判断する行為</li>
              </ol>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">第6条（広告について）</h2>
              <ol className="list-decimal pl-6 space-y-2 leading-relaxed">
                <li>本アプリには、第三者広告（AdMob）が表示される場合があります。</li>
                <li>利用者は、広告の表示について同意するものとします。</li>
                <li>広告の内容について、運営は一切の責任を負いません。</li>
                <li>広告の表示により生じた損害について、運営は一切の責任を負いません。</li>
              </ol>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">第7条（リワード広告）</h2>
              <ol className="list-decimal pl-6 space-y-2 leading-relaxed">
                <li>本アプリでは、リワード広告（報酬付き広告）を視聴することで、ゲーム内アイテム（タップストック）を獲得できます。</li>
                <li>リワード広告の視聴は任意であり、利用者の判断で行うものとします。</li>
                <li>リワード広告の視聴により獲得したアイテムは、本アプリ内でのみ利用可能です。</li>
                <li>リワード広告の視聴により生じた損害について、運営は一切の責任を負いません。</li>
              </ol>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">第8条（データの収集・利用）</h2>
              <ol className="list-decimal pl-6 space-y-2 leading-relaxed">
                <li>運営は、本アプリの提供に必要な範囲で、以下の情報を収集・利用する場合があります。
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>デバイス情報（OS、機種等）</li>
                    <li>アプリの利用状況</li>
                    <li>広告の表示・クリック情報</li>
                    <li>その他、本アプリの機能向上に必要な情報</li>
                  </ul>
                </li>
                <li>収集した情報は、本アプリの提供、改善、広告配信等の目的で利用します。</li>
                <li>個人情報の取扱いについては、別途定めるプライバシーポリシーに従います。</li>
              </ol>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">第9条（データの保存・削除）</h2>
              <ol className="list-decimal pl-6 space-y-2 leading-relaxed">
                <li>本アプリでは、ゲームの進行状況、統計データ等をローカルデバイスに保存します。</li>
                <li>利用者は、設定画面からデータをリセットすることができます。</li>
                <li>アプリのアンインストールにより、保存されたデータは削除される場合があります。</li>
                <li>データの消失により生じた損害について、運営は一切の責任を負いません。</li>
              </ol>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">第10条（知的財産権）</h2>
              <ol className="list-decimal pl-6 space-y-2 leading-relaxed">
                <li>本アプリおよびそのコンテンツに関する知的財産権は、運営または正当な権利者に帰属します。</li>
                <li>利用者は、本アプリおよびそのコンテンツを複製、改変、配布、販売等してはなりません。</li>
              </ol>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">第11条（免責事項）</h2>
              <ol className="list-decimal pl-6 space-y-2 leading-relaxed">
                <li>運営は、本アプリの利用により生じた損害について、一切の責任を負いません。</li>
                <li>運営は、本アプリの中断、停止、終了、変更等により生じた損害について、一切の責任を負いません。</li>
                <li>運営は、本アプリの利用により生じたデータの消失、破損等について、一切の責任を負いません。</li>
                <li>運営は、本アプリの利用により生じた第三者との間の紛争について、一切の責任を負いません。</li>
              </ol>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">第12条（アプリの提供の停止・終了）</h2>
              <ol className="list-decimal pl-6 space-y-2 leading-relaxed">
                <li>運営は、以下の場合には、利用者に事前の通知なく、本アプリの提供を停止または終了することができるものとします。
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>本アプリの保守、更新等を行う場合</li>
                    <li>システムの故障、障害等が発生した場合</li>
                    <li>その他、運営が必要と判断した場合</li>
                  </ul>
                </li>
                <li>運営は、本アプリの提供の停止または終了により生じた損害について、一切の責任を負いません。</li>
              </ol>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">第13条（準拠法・管轄裁判所）</h2>
              <ol className="list-decimal pl-6 space-y-2 leading-relaxed">
                <li>本規約は、日本法に準拠して解釈されるものとします。</li>
                <li>本規約に関して紛争が生じた場合には、運営の所在地を管轄する裁判所を専属的合意管轄とします。</li>
              </ol>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-amber-400 mb-4">第14条（その他）</h2>
              <ol className="list-decimal pl-6 space-y-2 leading-relaxed">
                <li>本規約に定めのない事項については、日本法に従うものとします。</li>
                <li>本規約の一部が無効または執行不能となった場合でも、その他の部分は有効に存続するものとします。</li>
              </ol>
            </section>

            <div className="text-right mt-12 pt-8 border-t border-amber-500/20">
              <p className="text-gray-400">制定日：2025年09月20日</p>
              <p className="text-gray-400 font-bold">本利用規約は、2025年09月20日から施行されます。</p>
            </div>

          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-black border-t border-amber-500/20 py-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-gray-400">
            © 2025 奇跡のブラックアウト. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
